import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DeepLinkRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const handleFirebaseDynamicLinkReplacement = () => {
      const params = new URLSearchParams(location.search);

      // Get the main parameters that Firebase Dynamic Links uses
      const link = params.get('link'); // The actual target URL
      const apn = params.get('apn'); // Android package name
      const isi = params.get('isi'); // iOS app store ID
      const ibi = params.get('ibi'); // iOS bundle ID
      const afl = params.get('afl'); // Android fallback link

      // Detect platform
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isAndroid = /android/.test(userAgent);
      const isMobile = isIOS || isAndroid;

      if (!isMobile) {
        // Desktop: Redirect to the link parameter (web fallback)
        if (link) {
          window.location.href = link;
        } else {
          window.location.href = '/';
        }
        return;
      }

      // Mobile: Try to open the app, fallback to store
      if (isIOS && ibi) {
        // iOS: Try Universal Link first, then App Store
        const universalLink = link || '/';

        // Try to open the app
        window.location.href = `${ibi}://${universalLink.replace(
          /^https?:\/\/[^/]+/,
          '',
        )}`;

        // Fallback to App Store after delay
        setTimeout(() => {
          if (isi) {
            window.location.href = `https://apps.apple.com/app/id${isi}`;
          }
        }, 1000);
      } else if (isAndroid && apn) {
        // Android: Try Intent, then Play Store
        const intentLink = link || '/';

        // Try to open the app with Intent
        window.location.href = `intent://${intentLink.replace(
          /^https?:\/\/[^/]+/,
          '',
        )}#Intent;scheme=https;package=${apn};end`;

        // Fallback to Play Store after delay
        setTimeout(() => {
          window.location.href = `https://play.google.com/store/apps/details?id=${apn}`;
        }, 1000);
      } else {
        // Mobile but no app info, go to link or fallback
        if (link) {
          window.location.href = link;
        } else if (afl) {
          window.location.href = afl;
        } else {
          window.location.href = '/';
        }
      }
    };

    handleFirebaseDynamicLinkReplacement();
  }, [location.search]);

  // Show a loading message briefly while redirect happens
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
        <h2 className="mb-2 text-xl font-semibold text-gray-700">
          Redirecting...
        </h2>
        <p className="text-gray-500">Please wait while we redirect you.</p>
      </div>
    </div>
  );
};

export default DeepLinkRedirect;
